import { Link } from "@tanstack/react-router";

function Smiley() {
    return (
        <svg className="fill-on-footer h-full w-full" viewBox="0 0 53.03 50.11">
            <defs>
                <clipPath id="clippath">
                    <rect width="53.03" height="50.11" />
                </clipPath>
            </defs>
            <g id="Layer_1-2" data-name="Layer 1" clipPath="url(#clippath)">
                <g>
                    <path d="M0,20.78v14.72c0,3.63.99,6.96,2.94,9.71,2.25,3.63,5.2,4.9,10.49,4.9h26.17c7.74,0,13.43-6.28,13.43-14.7v-14.63h-8.82v14.43c0,3.33-2.94,6.08-6.56,6.08H14.61c-3.33,0-5.78-2.35-5.78-5.79v-14.72H0Z" />
                    <path d="M12.76,10.63c2.94,0,5.32-2.38,5.32-5.32S15.7,0,12.76,0s-5.32,2.38-5.32,5.32,2.38,5.32,5.32,5.32" />
                    <path d="M40.27,10.63c2.94,0,5.32-2.38,5.32-5.32s-2.38-5.32-5.32-5.32-5.32,2.38-5.32,5.32,2.38,5.32,5.32,5.32" />
                </g>
                <rect x="22.45" y="15.11" width="8.13" height="8.13" />
            </g>
        </svg>
    );
}

export default function Footer() {
    return (
        <footer className="w-full bg-footer h-20 mt-auto">
            <Link to="/" className="h-full p-5 inline-block">
                <Smiley />
            </Link>
        </footer>
    );
}
